import { render, staticRenderFns } from "./postMessage.vue?vue&type=template&id=87dfa424&scoped=true&"
import script from "./postMessage.vue?vue&type=script&lang=js&"
export * from "./postMessage.vue?vue&type=script&lang=js&"
import style0 from "./postMessage.vue?vue&type=style&index=0&id=87dfa424&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dfa424",
  null
  
)

export default component.exports